import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from "react-redux";
import './Button.css'

// TODO - The `menu_login` has to be removed from the player logic.
function ConnectedButtonLogin({ style, showUsername = false, connected, user }) {
  const styleAvatar = { backgroundImage: `url(${(user && user.cover) ? user.cover.replace(`500x500`, `105x105`).replace(`1400x1400`, `105x105`) : Config.DEFAULT_IMG })` }
  const openSettings = () => {}
  const storeAuth = useSelector( state => state.storeAuth );
  const login = () => {
    if (storeAuth && storeAuth.welcome) { storeAuth.welcome() }
  }
  const signup = () => {
    if (storeAuth && storeAuth.registration) { storeAuth.registration() }
  }
  const signin = () => {
    if (storeAuth && storeAuth.signin) { storeAuth.signin() }
  }
  return (
    <>
      { !connected
        ? (
          <div className={'flexRow group-section-buttons'}>
            <div className={`section-button type-medium fz12`} onClick={signup}>Sign Up</div>
            <div className={`section-button sb-secondary type-medium fz12`} onClick={signin}>Log In</div>
          </div>
        )
        : (
          <div className={'flexRow'} style={{alignItems: 'center'}}>
            <div className={`avatar-login`} style={styleAvatar} onClick={openSettings} />
            { showUsername && <span className={'type-medium fz13 type-secondary'}>{ user && user.name }</span> }
          </div>
        )
      }
      <div
        id="menu_login"
        className={`topbutton nicefont button-login none`}
        style={{...style, padding: `6px 8px`}}
        onClick={login}
      />
    </>
  )
}

ConnectedButtonLogin.propTypes = {
  style: PropTypes.object,
  showUsername: PropTypes.bool
}

const ButtonLogin = connect(
  state => ({
    connected: state.isConnected,
    user: state.user
  })
)(ConnectedButtonLogin);

export default ButtonLogin;
